module.exports = __webpack_public_path__ + "img/8_27.41784e6f.png";